function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var isRefreshing = false;
var failedRequestsQueue = [];
var processQueue = function processQueue(error, accessToken) {
  failedRequestsQueue.forEach(function (request) {
    if (error) {
      request.onFailure(error);
    } else {
      request.onSuccess(accessToken);
    }
    failedRequestsQueue = [];
  });
};
var applyAppTokenRefreshInterceptor = function applyAppTokenRefreshInterceptor(_ref) {
  var client = _ref.client,
    handleRefreshToken = _ref.handleRefreshToken,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    options = _ref.options;
  var shouldIntercept = function shouldIntercept(error) {
    try {
      var _error$response;
      return (error == null || (_error$response = error.response) == null ? void 0 : _error$response.status) === 401;
    } catch (e) {
      return false;
    }
  };
  var currentOptions = _extends({
    shouldIntercept: shouldIntercept
  }, options);
  var interceptor = function interceptor(error) {
    var originalConfig = error.config;
    if (currentOptions != null && currentOptions.shouldIntercept != null && currentOptions.shouldIntercept(error)) {
      if (!isRefreshing) {
        isRefreshing = true;
        handleRefreshToken().then(function (accessToken) {
          client.defaults.headers.token = accessToken;
          if (onSuccess) {
            onSuccess(accessToken);
          }
          processQueue(null, accessToken);
        })["catch"](function (error) {
          processQueue(error, null);
          if (currentOptions != null && currentOptions.log) {
            console.log('intercepted error<>>', error);
          }
          if (onError) {
            onError(error);
          }
        })["finally"](function () {
          isRefreshing = false;
        });
      }
      return new Promise(function (resolve, reject) {
        failedRequestsQueue.push({
          onSuccess: function onSuccess(token) {
            originalConfig.headers.token = token;
            resolve(client(originalConfig));
          },
          onFailure: function onFailure(err) {
            reject(err);
          }
        });
      });
    }
    return Promise.reject(error);
  };
  client.interceptors.response.use(undefined, interceptor);
};

export { applyAppTokenRefreshInterceptor };
//# sourceMappingURL=apply-refresh-token.esm.js.map
